import { render, staticRenderFns } from "./DeployedInstance.vue?vue&type=template&id=71089344"
import script from "./DeployedInstance.vue?vue&type=script&lang=ts"
export * from "./DeployedInstance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports